<template>
  <div>
    <vxe-card>
      <vxe-table
        ref="orderTable"
        :column-config="{resizable: true}"
        :data="orders"
        :export-config="{}"
        :height="orderScrollY"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe
        @cell-click="({row})=>rowClick(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.loadingOrderNo" width="150"/>
        <vxe-column field="order.invoiceTime" title="business.label.generatedTime" width="170"/>
        <vxe-column field="order.operator" title="business.label.operator"/>
        <vxe-column field="carrier.name" title="business.label.carrierName" width="200"/>
        <vxe-column field="carrier.expressCode" title="business.label.expressCode" width="100"/>
        <vxe-column field="order.numberOfOrder" title="business.label.orderCount"/>
        <vxe-column field="order.numberOfCustomer" title="business.label.customerCount"/>
        <vxe-column field="order.notes" title="business.label.notes"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="deleteOrder(row.order)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      <vxe-table
        ref="detailTable"
        :column-config="{resizable: true}"
        :data="details"
        :export-config="{}"
        :footer-data="footerData"
        :height="detailScrollY"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-footer
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="customer.no" title="business.label.customerNo" width="100"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="pickupMode.name" title="business.label.shipmentMode" width="80"/>
        <vxe-column field="detail.wave" title="business.label.wave" width="100"/>
        <vxe-column field="detail.ordinal" title="business.label.orderOfLoading" width="60"/>
        <vxe-column field="statistics.numberOfItem" title="business.label.numberOfItem" width="60"/>
        <vxe-column field="statistics.numberOfFcl" title="business.label.numberOfFcl" width="60"/>
        <vxe-column field="statistics.numberOfLcl" title="business.label.numberOfLcl" width="60"/>
        <vxe-column field="statistics.numberOfEach" title="business.label.numberOfEach" width="60"/>
        <vxe-column field="statistics.numberOfRefrigeration" title="business.label.numberOfRefrigeration" width="60"/>
        <vxe-column field="statistics.numberOfValuable" title="business.label.numberOfValuable" width="60"/>
        <vxe-column field="statistics.numberOfImportation" title="business.label.numberOfImportation" width="60"/>
        <vxe-column field="statistics.numberOfPsychotropic" title="business.label.numberOfPsychotropic" width="60"/>
        <vxe-column field="statistics.numberOfSpecial" title="business.label.numberOfSpecial" width="60"/>
        <vxe-column field="statistics.numberOfPeptides" title="business.label.numberOfPeptides" width="60"/>
        <vxe-column field="statistics.numberOfGift" title="business.label.numberOfGift" width="60"/>
        <vxe-column field="statistics.numberOfOthers" title="business.label.numberOfOthers" width="60"/>
        <vxe-column field="statistics.numberOfSupervised" title="business.label.numberOfSupervised" width="60"/>
        <vxe-column field="statistics.standardCaseQuantity" title="business.label.standardCaseQuantity" width="100"/>
        <vxe-column field="statistics.volume" title="business.label.volume" width="100"/>
        <vxe-column field="statistics.weight" title="business.label.weight" width="100"/>
        <vxe-column field="statistics.amount" title="business.label.amount" width="100"/>
        <vxe-column field="statistics.numberOfPlasticBox" title="business.label.numberOfPlasticBox" width="60"/>
        <vxe-column field="statistics.numberOfCartonBox" title="business.label.numberOfCartonBox" width="60"/>
        <vxe-column field="statistics.numberOfInsulationBox" title="business.label.numberOfInsulationBox" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="deleteDetail(row.detail)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import { LoadingOrder } from '@/api/dto/order/LoadingOrder'
import { OrderType } from '@/api/dto/common/OrderType'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'Arranged',
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      order: new LoadingOrder(),
      orders: [],
      details: [],
      page: 1,
      size: 5,
      contentSize: 0,
      footerData: [
        {
          'customer.no': '合计',
          'statistics.numberOfItem': 0,
          'statistics.numberOfFcl': 0,
          'statistics.numberOfLcl': 0,
          'statistics.numberOfEach': 0,
          'statistics.numberOfRefrigeration': 0,
          'statistics.numberOfValuable': 0,
          'statistics.numberOfImportation': 0,
          'statistics.numberOfPsychotropic': 0,
          'statistics.numberOfSpecial': 0,
          'statistics.numberOfPeptides': 0,
          'statistics.numberOfGift': 0,
          'statistics.numberOfOthers': 0,
          'statistics.numberOfSupervised': 0,
          'statistics.standardCaseQuantity': 0,
          'statistics.volume': 0,
          'statistics.weight': 0,
          'statistics.amount': 0,
          'statistics.plasticBox': 0,
          'statistics.cartonBox': 0,
          'statistics.insulationBox': 0
        }
      ],
      orderScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.225),
      detailScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.57)
    }
  },
  created() {
    this.refresh()
  },
  props: {
    orderType: {
      type: OrderType,
      default: null
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch(order) {
      this.loading = true
      const args = { orderStatus: 0 }
      if (order) {
        args['order.id'] = order.id
      }
      findAll('loadingOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.orders = res.result
          if (this.orders.length > 0) {
            const current = this.orders[0]
            this.$refs.orderTable.setRadioRow(current)
            this.$refs.orderTable.setCurrentRow(current)
            this.rowClick(current)
          }
        }
      }).finally(() => this.loading = false)
    },
    getDetails() {
      this.loading = true
      findAll('loadingDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.details = res.result
          this.footerData = [
            {
              'customer.no': '合计',
              'statistics.numberOfItem': this.details.reduce((total, item) => total + item.statistics.numberOfItem, 0),
              'statistics.numberOfFcl': this.details.reduce((total, item) => total + item.statistics.numberOfFcl, 0),
              'statistics.numberOfLcl': this.details.reduce((total, item) => total + item.statistics.numberOfLcl, 0),
              'statistics.numberOfEach': this.details.reduce((total, item) => total + item.statistics.numberOfEach, 0),
              'statistics.numberOfRefrigeration': this.details.reduce((total, item) => total + item.statistics.numberOfRefrigeration, 0),
              'statistics.numberOfValuable': this.details.reduce((total, item) => total + item.statistics.numberOfValuable, 0),
              'statistics.numberOfImportation': this.details.reduce((total, item) => total + item.statistics.numberOfImportation, 0),
              'statistics.numberOfPsychotropic': this.details.reduce((total, item) => total + item.statistics.numberOfPsychotropic, 0),
              'statistics.numberOfSpecial': this.details.reduce((total, item) => total + item.statistics.numberOfSpecial, 0),
              'statistics.numberOfPeptides': this.details.reduce((total, item) => total + item.statistics.numberOfPeptides, 0),
              'statistics.numberOfGift': this.details.reduce((total, item) => total + item.statistics.numberOfGift, 0),
              'statistics.numberOfOthers': this.details.reduce((total, item) => total + item.statistics.numberOfOthers, 0),
              'statistics.numberOfSupervised': this.details.reduce((total, item) => total + item.statistics.numberOfSupervised, 0),
              'statistics.standardCaseQuantity': Number(this.details.reduce((total, item) => total + item.statistics.standardCaseQuantity, 0)).toFixed(2),
              'statistics.volume': Number(this.details.reduce((total, item) => total + item.statistics.volume, 0)).toFixed(2),
              'statistics.weight': Number(this.details.reduce((total, item) => total + item.statistics.weight, 0)).toFixed(6),
              'statistics.amount': Number(this.details.reduce((total, item) => total + item.statistics.amount, 0)).toFixed(5),
              'statistics.numberOfPlasticBox': this.details.reduce((total, item) => total + item.statistics.numberOfPlasticBox, 0),
              'statistics.numberOfCartonBox': this.details.reduce((total, item) => total + item.statistics.numberOfCartonBox, 0),
              'statistics.numberOfInsulationBox': this.details.reduce((total, item) => total + item.statistics.numberOfInsulationBox, 0)
            }
          ]
        }
      }).finally(() => this.loading = false)
    },
    rowClick(row) {
      this.order = new LoadingOrder(BaseObject.merge(row, 'order'))
      this.$emit('rowClick', this.order.no)
      this.getDetails()
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    addOrder() {
      this.loading = true
      const order = {
        warehouse: this.warehouse,
        orderType: this.orderType,
        operator: this.operator.name,
        distributionType: 2,
        details: []
      }
      post(api.deliverySave, {}, order).then(res => {
        if (res.success) {
          this.$message.success('新增装车单成功')
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    addDetail(details) {
      this.loading = true
      const order = {
        warehouse: this.warehouse,
        ...this.order.toJSONObject(),
        details: details.map(item => {
          return {
            customer: item.customer,
            wave: item.dispatch.wave
          }
        })
      }
      post(api.deliverySave, {}, order).then(res => {
        if (res.success) {
          this.$message.success('新增装车单明细成功')
          this.$emit('refreshUnArranged')
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    deleteOrder(order) {
      this.loading = true
      post(api.deliveryCancelOrder, {}, { id: order.id }).then(res => {
        if (res.success) {
          this.$message.success('删除装车单成功')
          this.$emit('refreshUnArranged')
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    deleteDetail(detail) {
      this.loading = true
      post(api.deliveryCancelDetail, {}, { ids: [detail.id] }).then(res => {
        if (res.success) {
          this.$message.success('删除明细成功')
          this.$emit('refreshUnArranged')
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>